import { useEffect, useState } from 'react';

import getTimeLeft from '../../../utils/time-left';

type UseTimeLeftProps = {
  /** The time that the interview was started */
  startedAt: Date | null;

  /** The interview duration, in seconds */
  duration: number | null;
};

const useTimeLeft = ({ startedAt, duration }: UseTimeLeftProps) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!startedAt || !duration) {
      return;
    }

    const currentTimeLeft = getTimeLeft(startedAt, duration);
    setTimeLeft(currentTimeLeft);

    // If more than 2 hours left, update every hour, otherwise update every second
    const interval = currentTimeLeft > 7200 ? 3600 * 1000 : 1000;
    const intervalId = setInterval(() => {
      setTimeLeft(getTimeLeft(startedAt, duration));
    }, interval);

    return () => {
      clearInterval(intervalId);
    };
  }, [startedAt, duration]);

  return timeLeft;
};

export default useTimeLeft;
